import { makeAutoObservable, reaction } from 'mobx';

import { menuConfig } from '@components/AppRouter/menuConfig/menuConfig';
import { customizeRoutes, filterRoutes } from '@components/AppRouter/routeConfig/utils';
import type { DesignMenuRouteInterface } from '@common/DesignLayout/DesignMenu/interfaces';
import type { KeycloakUserDto } from '@src/api';

import { userStore } from '../userStore';
import type { Route as DefaultRoute, Route } from '../../components/AppRouter/types';

export type MenuRoute = DefaultRoute & { key?: string | number };

class DesignMenuStore {
  menuData: (DesignMenuRouteInterface | MenuRoute)[] = [];

  menuRefData: DefaultRoute[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  setMenuRefData = ({ user }: { user?: KeycloakUserDto | null }) => {
    const setCustomRoutes = (route: Route): Route => route;

    this.menuRefData = customizeRoutes({ routes: filterRoutes({ routes: menuConfig, user }), setCustomRoutes });
  };

  addMenuData = (data: DesignMenuRouteInterface | MenuRoute) => {
    this.menuData = [data];
  };

  rmMenuData = (removeAll = false) => {
    if (removeAll) {
      this.menuData = [];
    } else {
      const newData = [...this.menuData];
      newData.pop();
      this.menuData = newData;
    }
  };
}

export const designMenuStore = new DesignMenuStore();

reaction(
  () => userStore.user,
  (user) => designMenuStore.setMenuRefData({ user: user }),
);
